import type { UserType } from "@/types/graphql/admin";

export const getUserDisplayName = (user: UserType) => {
  if (user.displayName) return user.displayName;

  const firstName = user.firstName?.trim();
  const lastName = user.lastName?.trim();

  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }

  if (firstName) {
    return firstName;
  }

  if (lastName) {
    return lastName;
  }

  return user.email?.split("@")[0] || user.phone || "User";
};
